export const ORIGINAL = { title: "None", id: "none" };

export const defaultEnterPayload = {
  motion: "enter",
  loop: false,
  delay: 0,
  easing: "easeOutQuart",
  direction: "normal",
  start_time: 0,
  trans_duration: 1000,
  end_time: 1000,
  characterLevel: false,
};

const defaultExitPayload = {
  motion: "exit",
  trans_duration: 1000,
  delay: 0,
  easing: "easeOutQuart",
  direction: "normal",
  start_time: 5000,
  end_time: 6000,
  characterLevel: false,
};

export const STILL_EFFECT = {
  ...defaultEnterPayload,
  type: "still",
  motion: "still",
  trans_duration: 5000,
  start_time: 1000,
  end_time: 6000,
};

// Breathe animation
const BREATHE = {
  id: "breathe",
  title: "Breathe",
  variants: [
    {
      title: "Breathe",
      type: "breathe",
      ...defaultEnterPayload,
      trans_duration: 4000,
      start_time: 0,
      end_time: 4000,
      parentId: "breathe",
    },
  ],
};

// Fly effect
const FLY_IN_LEFT = {
  title: "Left",
  type: "fly_in_left",
  ...defaultEnterPayload,
  parentId: "fly_in",
};

const FLY_IN_RIGHT = {
  title: "Right",
  type: "fly_in_right",
  ...defaultEnterPayload,
  parentId: "fly_in",
};

const FLY_IN_TOP = {
  title: "Top",
  type: "fly_in_top",
  ...defaultEnterPayload,
  parentId: "fly_in",
};

const FLY_IN_BOTTOM = {
  title: "Bottom",
  type: "fly_in_bottom",
  ...defaultEnterPayload,
  parentId: "fly_in",
};

const FLY_IN = {
  title: "Fly In",
  id: "fly_in",
  variants: [FLY_IN_LEFT, FLY_IN_RIGHT, FLY_IN_TOP, FLY_IN_BOTTOM],
};

const FLY_OUT_LEFT = {
  title: "Left",
  type: "fly_out_left",
  ...defaultExitPayload,
  parentId: "fly_out",
};
const FLY_OUT_RIGHT = {
  title: "Right",
  type: "fly_out_right",
  ...defaultExitPayload,
  parentId: "fly_out",
};

const FLY_OUT_TOP = {
  title: "Top",
  type: "fly_out_top",
  ...defaultExitPayload,
  parentId: "fly_out",
};

const FLY_OUT_BOTTOM = {
  title: "Bottom",
  type: "fly_out_bottom",
  ...defaultExitPayload,
  parentId: "fly_out",
};

const FLY_OUT = {
  title: "Fly Out",
  id: "fly_out",
  variants: [FLY_OUT_LEFT, FLY_OUT_RIGHT, FLY_OUT_TOP, FLY_OUT_BOTTOM],
};

// Shift effect
const SHIFT_LEFT = {
  title: "Left",
  type: "shift_left",
  ...defaultEnterPayload,
  parentId: "shift",
};

const SHIFT_RIGHT = {
  title: "Right",
  type: "shift_right",
  ...defaultEnterPayload,
  parentId: "shift",
};

const SHIFT_TOP = {
  title: "Top",
  type: "shift_top",
  ...defaultEnterPayload,
  parentId: "shift",
};

const SHIFT_BOTTOM = {
  title: "Bottom",
  type: "shift_bottom",
  ...defaultEnterPayload,
  parentId: "shift",
};

const SHIFT = {
  title: "Shift",
  id: "shift",
  variants: [SHIFT_LEFT, SHIFT_RIGHT, SHIFT_TOP, SHIFT_BOTTOM],
};

// Fade effect.
const FADE_OUT = {
  title: "Fade Out",
  id: "fade_out",

  variants: [
    {
      title: "Fade out",
      type: "fade_out",
      ...defaultExitPayload,
      parentId: "fade_out",
    },
  ],
};

const FADE_IN = {
  title: "Fade In",
  id: "fade_in",

  variants: [
    {
      title: "Fade in",
      type: "fade_in",
      ...defaultEnterPayload,
      easing: "linear",
      parentId: "fade_in",
    },
  ],
};

// Tumble effect.
const TUMBLE_IN = {
  title: "Tumble In",
  id: "tumble_in",

  variants: [
    {
      title: "Tumble in",
      type: "tumble_in",
      ...defaultEnterPayload,
      easing: "easeOutQuart",
      parentId: "tumble_in",
    },
  ],
};

const TUMBLE_OUT = {
  title: "Tumble Out",
  id: "tumble_out",

  variants: [
    {
      title: "Tumble out",
      type: "tumble_out",
      ...defaultExitPayload,
      parentId: "tumble_out",
    },
  ],
};

// Wipe effect
const WIPE_IN_LEFT = {
  title: "Left",
  type: "wipe_in_left",
  ...defaultEnterPayload,
  parentId: "wipe_in",
};

const WIPE_IN_RIGHT = {
  title: "Right",
  type: "wipe_in_right",
  ...defaultEnterPayload,
  parentId: "wipe_in",
};

const WIPE_IN_TOP = {
  title: "Top",
  type: "wipe_in_top",
  ...defaultEnterPayload,
  parentId: "wipe_in",
};

const WIPE_IN_BOTTOM = {
  title: "Bottom",
  type: "wipe_in_bottom",
  ...defaultEnterPayload,
  parentId: "wipe_in",
};

const WIPE_IN = {
  title: "Wipe In",
  id: "wipe_in",
  variants: [WIPE_IN_LEFT, WIPE_IN_RIGHT, WIPE_IN_TOP, WIPE_IN_BOTTOM],
};

const WIPE_OUT_LEFT = {
  title: "Left",
  type: "wipe_out_left",
  ...defaultExitPayload,
  parentId: "wipe_out",
};
const WIPE_OUT_RIGHT = {
  title: "Right",
  type: "wipe_out_right",
  ...defaultExitPayload,
  parentId: "wipe_out",
};

const WIPE_OUT_TOP = {
  title: "Top",
  type: "wipe_out_top",
  ...defaultExitPayload,
  parentId: "wipe_out",
};

const WIPE_OUT_BOTTOM = {
  title: "Bottom",
  type: "wipe_out_bottom",
  ...defaultExitPayload,
  parentId: "wipe_out",
};

const WIPE_OUT = {
  title: "Wipe Out",
  id: "wipe_out",
  variants: [WIPE_OUT_LEFT, WIPE_OUT_RIGHT, WIPE_OUT_TOP, WIPE_OUT_BOTTOM],
};

//Zoom effect

const ZOOM = {
  title: "Zoom In",
  type: "zoom_in",
  ...defaultEnterPayload,
  parentId: "zoom_in",
};

// const ZOOM_IN_BOUNCE = {
//   title: "Bounce",
//   type: "zoom_in_bounce",
//   ...defaultEnterPayload,
//   easing: 'easeOutBounce',
// };

const ZOOM_IN = {
  title: "Zoom In",
  id: "zoom_in",
  variants: [
    ZOOM,
    // ZOOM_IN_BOUNCE
  ],
};

const ZOOM_OUT_EFFECT = {
  title: "Zoom Out",
  type: "zoom_out",
  ...defaultExitPayload,
  parentId: "zoom_out",
};

// const ZOOM_OUT_BOUNCE = {
//   title: "Bounce",
//   type: "zoom_out_bounce",
//   ...defaultExitPayload,
// };

// const ZOOM_OUT = {
//   title: "Zoom Out",
//   id: "zoom",
//   variants: [ZOOM_OUT_EFFECT, ZOOM_OUT_BOUNCE],
// };

// Reveal Effect
const REVEAL_IN_LEFT = {
  title: "Left",
  type: "reveal_in_left",
  ...defaultEnterPayload,
  parentId: "reveal_in",
};

const REVEAL_IN_RIGHT = {
  title: "Right",
  type: "reveal_in_right",
  ...defaultEnterPayload,
  parentId: "reveal_in",
};

const REVEAL_IN_TOP = {
  title: "Top",
  type: "reveal_in_top",
  ...defaultEnterPayload,
  parentId: "reveal_in",
};

const REVEAL_IN_BOTTOM = {
  title: "Bottom",
  type: "reveal_in_bottom",
  ...defaultEnterPayload,
  parentId: "reveal_in",
};

const REVEAL_IN = {
  title: "Reveal In",
  id: "reveal_in",
  variants: [REVEAL_IN_LEFT, REVEAL_IN_RIGHT, REVEAL_IN_TOP, REVEAL_IN_BOTTOM],
};

const REVEAL_OUT_LEFT = {
  title: "Left",
  type: "reveal_out_left",
  ...defaultExitPayload,
  parentId: "reveal_out",
};
const REVEAL_OUT_RIGHT = {
  title: "Right",
  type: "reveal_out_right",
  ...defaultExitPayload,
  parentId: "reveal_out",
};

const REVEAL_OUT_TOP = {
  title: "Top",
  type: "reveal_out_top",
  ...defaultExitPayload,
  parentId: "reveal_out",
};

const REVEAL_OUT_BOTTOM = {
  title: "Bottom",
  type: "reveal_out_bottom",
  ...defaultExitPayload,
  parentId: "reveal_out",
};

const REVEAL_OUT = {
  title: "Reveal Out",
  id: "reveal_out",
  variants: [
    REVEAL_OUT_LEFT,
    REVEAL_OUT_RIGHT,
    REVEAL_OUT_TOP,
    REVEAL_OUT_BOTTOM,
  ],
};

// Ficker effect
const FLICKER = {
  title: "Flicker",
  id: "flicker",
  variants: [
    {
      title: "Flicker",
      type: "flicker",
      ...defaultEnterPayload,
      parentId: "flicker",
    },
  ],
};

// Pulse effect
const PULSE = {
  title: "Pulse",
  id: "pulse",
  variants: [
    {
      title: "Pulse",
      type: "pulse",
      ...defaultEnterPayload,
      trans_duration: 3000,
      end_time: 3000,
      parentId: "pulse",
    },
  ],
};

// Disco effect
const DISCO = {
  title: "Disco",
  id: "disco",
  variants: [
    {
      title: "Disco",
      type: "disco",
      ...defaultEnterPayload,
      parentId: "disco",
    },
  ],
};

// Glitch effect
const GLITCH = {
  title: "Glitch",
  id: "glitch",
  variants: [
    {
      title: "glitch",
      type: "glitch",
      ...defaultEnterPayload,
      parentId: "glitch",
    },
  ],
};

// Stomp effect
const STOMP = {
  title: "Stomp",
  id: "stomp",
  variants: [
    {
      title: "stomp",
      type: "stomp",
      ...defaultEnterPayload,
      start_time: 0,
      trans_duration: 500,
      end_time: 500,
      parentId: "stomp",
    },
  ],
};

const BLOCK_REVEAL_IN_LEFT = {
  title: "Left",
  type: "block_in_left",
  ...defaultEnterPayload,
  parentId: "block_in",
};

const BLOCK_REVEAL_IN_RIGHT = {
  title: "Right",
  type: "block_in_right",
  ...defaultEnterPayload,
  parentId: "block_in",
};

const BLOCK_REVEAL_IN_TOP = {
  title: "Top",
  type: "block_in_top",
  ...defaultEnterPayload,
  parentId: "block_in",
};

const BLOCK_REVEAL_IN_BOTTOM = {
  title: "Bottom",
  type: "block_in_bottom",
  ...defaultEnterPayload,
  parentId: "block_in",
};

const BLOCK_REVEAL_IN = {
  title: "Block Reveal In",
  id: "block_in",
  variants: [
    BLOCK_REVEAL_IN_LEFT,
    BLOCK_REVEAL_IN_RIGHT,
    BLOCK_REVEAL_IN_TOP,
    BLOCK_REVEAL_IN_BOTTOM,
  ],
};

const BLOCK_REVEAL_OUT_LEFT = {
  title: "Left",
  type: "block_out_left",
  ...defaultExitPayload,
  parentId: "block_out",
};
const BLOCK_REVEAL_OUT_RIGHT = {
  title: "Right",
  type: "block_out_right",
  ...defaultExitPayload,
  parentId: "block_out",
};

const BLOCK_REVEAL_OUT_TOP = {
  title: "Top",
  type: "block_out_top",
  ...defaultExitPayload,
  parentId: "block_out",
};

const BLOCK_REVEAL_OUT_BOTTOM = {
  title: "Bottom",
  type: "block_out_bottom",
  ...defaultExitPayload,
  parentId: "block_out",
};

const BLOCK_REVEAL_OUT = {
  title: "Block Reveal Out",
  id: "block_out",
  variants: [
    BLOCK_REVEAL_OUT_LEFT,
    BLOCK_REVEAL_OUT_RIGHT,
    BLOCK_REVEAL_OUT_TOP,
    BLOCK_REVEAL_OUT_BOTTOM,
  ],
};

const GREAT_THINKER = {
  title: "Great Thinker",
  id: "great_thinker",
  characterLevel: true,
  // video: "https://assets.simplified.co/videos/text/text_great_thinker.gif",
  variants: [
    {
      title: "great thinker",
      type: "great_thinker",
      ...defaultEnterPayload,
      easing: "linear",
      parentId: "great_thinker",
    },
  ],
};

const SUNNY_MORNINGS = {
  title: "Sunny Mornings",
  id: "sunny_mornings",
  characterLevel: true,
  // video: "https://assets.simplified.co/videos/text/text_sunny_morning.gif",
  variants: [
    {
      title: "sunny mornings",
      type: "sunny_mornings",
      ...defaultEnterPayload,
      parentId: "sunny_mornings",
      easing: "easeOutExpo",
    },
  ],
};

const RISING_STRONG_IN = {
  title: "Rising Strong In",
  id: "rising_strong_in",
  characterLevel: true,
  // video: "https://assets.simplified.co/videos/text/text_rising_strong.gif",

  variants: [
    {
      title: "rising strong in",
      type: "rising_strong_in",
      ...defaultEnterPayload,
      parentId: "rising_strong_in",
      easing: "easeOutExpo",
    },
  ],
};

const RISING_STRONG_OUT = {
  title: "Rising Strong Out",
  id: "rising_strong_out",
  characterLevel: true,
  // video: "https://assets.simplified.co/videos/text/text_rising_strong.gif",

  variants: [
    {
      title: "rising strong out",
      type: "rising_strong_out",
      ...defaultExitPayload,
      parentId: "rising_strong_out",
      easing: "easeOutExpo",
    },
  ],
};

const MADE_WITH_LOVE = {
  title: "Made With Love",
  id: "made_with_love",
  characterLevel: true,
  // video: "https://assets.simplified.co/videos/text/text_made_with_love.gif",

  variants: [
    {
      title: "made with love",
      type: "made_with_love",
      ...defaultEnterPayload,
      parentId: "made_with_love",
      easing: "easeOutExpo",
    },
  ],
};

const BEAUTIFUL_QUESTIONS = {
  title: "Beautiful Questions",
  id: "beautiful_questions",
  characterLevel: true,
  // video: "https://assets.simplified.co/videos/text/text_beautiful_questions.gif",

  variants: [
    {
      title: "beautiful questions",
      type: "beautiful_questions",
      ...defaultEnterPayload,
      parentId: "beautiful_questions",
      easing: "easeOutElastic",
    },
  ],
};

const DOMINO_DREAMS = {
  title: "Domino Dreams",
  id: "domino_dreams",
  characterLevel: true,
  // video: "https://assets.simplified.co/videos/text/text_domino_dreams.gif",

  variants: [
    {
      title: "domino dreams",
      type: "domino_dreams",
      ...defaultEnterPayload,
      parentId: "domino_dreams",
      easing: "easeOutElastic",
    },
  ],
};

const FIND_YOUR_ELEMENT = {
  title: "Find Your Element",
  id: "find_your_element",
  characterLevel: true,
  // video: "https://assets.simplified.co/videos/text/text_find_your_element.gif",

  variants: [
    {
      title: "find your element",
      type: "find_your_element",
      ...defaultEnterPayload,
      trans_duration: 2000,
      parentId: "find_your_element",
      easing: "easeOutExpo",
    },
  ],
};

const THURSDAY = {
  title: "Thursday",
  id: "thursday",
  characterLevel: true,
  // video: "https://assets.simplified.co/videos/text/text_thursday.gif",

  variants: [
    {
      title: "thursday",
      type: "thursday",
      ...defaultEnterPayload,
      trans_duration: 2000,
      parentId: "thursday",
      easing: "easeOutExpo",
    },
  ],
};

const HELLO_GOODBYE = {
  title: "Hello Goodbye",
  id: "hello_goodbye",
  characterLevel: true,
  // video: "https://assets.simplified.co/videos/text/text_hello_goodbye.gif",

  variants: [
    {
      title: "hello goodbye",
      type: "hello_goodbye",
      ...defaultEnterPayload,
      trans_duration: 2000,
      parentId: "hello_goodbye",
      easing: "easeOutExpo",
    },
  ],
};

const COFFEE_MORNINGS = {
  title: "Coffee Mornings",
  id: "coffee_mornings",
  characterLevel: true,
  // video: "https://assets.simplified.co/videos/text/text_coffee_morning.gif",

  variants: [
    {
      title: "coffee mornings",
      type: "coffee_mornings",
      ...defaultEnterPayload,
      parentId: "coffee_mornings",
      easing: "easeOutElastic",
    },
  ],
};

const A_NEW_PRODUCTION_IN = {
  title: "A New Production In",
  id: "a_new_production_in",
  characterLevel: true,
  // video: "https://assets.simplified.co/videos/text/text_new_production.gif",
  variants: [
    {
      title: "a new production in",
      type: "a_new_production_in",
      ...defaultEnterPayload,
      parentId: "a_new_production_in",
      easing: "easeOutExpo",
    },
  ],
};

const A_NEW_PRODUCTION_OUT = {
  title: "A New Production Out",
  id: "a_new_production_out",
  characterLevel: true,
  // video: "https://assets.simplified.co/videos/text/text_new_production.gif",
  variants: [
    {
      title: "a new production out",
      type: "a_new_production_out",
      ...defaultExitPayload,
      parentId: "a_new_production_out",
      easing: "easeOutExpo",
    },
  ],
};

const SIGNALS_NOISES = {
  title: "Signals & Noises",
  id: "signals_noises",
  characterLevel: true,

  variants: [
    {
      title: "signals noises",
      type: "signals_noises",
      ...defaultEnterPayload,
    },
  ],
};

export const enterEffects = [
  ORIGINAL,
  FLY_IN,
  FADE_IN,
  WIPE_IN,
  ZOOM_IN,
  REVEAL_IN,
  BLOCK_REVEAL_IN,
  SHIFT,
  TUMBLE_IN,
  FLICKER,
  PULSE,
  GLITCH,
  DISCO,
  STOMP,
  BREATHE,
  GREAT_THINKER,
  SUNNY_MORNINGS,
  RISING_STRONG_IN,
  MADE_WITH_LOVE,
  BEAUTIFUL_QUESTIONS,
  DOMINO_DREAMS,
  FIND_YOUR_ELEMENT,
  THURSDAY,
  HELLO_GOODBYE,
  COFFEE_MORNINGS,
  A_NEW_PRODUCTION_IN,
  // SIGNALS_NOISES,
];

export const exitEffects = [
  ORIGINAL,
  FLY_OUT,
  FADE_OUT,
  WIPE_OUT,
  TUMBLE_OUT,
  // ZOOM_OUT,
  REVEAL_OUT,
  BLOCK_REVEAL_OUT,
  RISING_STRONG_OUT,
  A_NEW_PRODUCTION_OUT,
];

// Presets
// const FLY_IN_BOUNCE = {
//   title: "Top",
//   type: "fly_in_top",
//   ...defaultEnterPayload,
// };

// const BOUNCE_PRESET = {
//   title: "Bounce",
//   id: "bounce",

//   sequence: [
//     {
//       ...FLY_IN_TOP,
//       easing: "easeOutBounce",
//     },
//     STILL_EFFECT,
//   ],
// };

const FADE_PRESET = {
  title: "Fade",
  id: "fade",
  video: "https://assets.simplified.co/videos/presets/fade4.mp4",
  sequence: [FADE_IN["variants"][0], STILL_EFFECT],
};

const ZOOM_PRESET = {
  title: "Zoom",
  id: "zoom",
  video: "https://assets.simplified.co/videos/presets/zoom4.mp4",
  sequence: [ZOOM, STILL_EFFECT],
};

const TEXT_BLOCK_PRESET = {
  title: "Text Block",
  id: "text_block",
  video: "https://assets.simplified.co/videos/presets/text_block4.mp4",
  sequence: [BLOCK_REVEAL_IN_LEFT, STILL_EFFECT],
};

const TEXT_POP_PRESET = {
  title: "Text Pop",
  id: "textPop",
  video: "https://assets.simplified.co/videos/presets/text_pop4.mp4",
  sequence: [ZOOM, STILL_EFFECT],
};

const TEXT_BASELINE_PRESET = {
  title: "Text Baseline",
  id: "textBaseline",
  video: "https://assets.simplified.co/videos/presets/text_baseline4.mp4",
  sequence: [REVEAL_IN_BOTTOM, STILL_EFFECT],
};

const POP_PRESET = {
  title: "Pop",
  id: "pop",
  video: "https://assets.simplified.co/videos/presets/pop4.mp4",
  sequence: [ZOOM, STILL_EFFECT],
};

const BASELINE_PRESET = {
  title: "Baseline",
  id: "baseline",
  video: "https://assets.simplified.co/videos/presets/baseline4.mp4",
  sequence: [REVEAL_IN_BOTTOM, STILL_EFFECT],
};

const NEON_FLICKER_PRESET = {
  title: "Neon Flicker",
  id: "neon",
  video: "https://assets.simplified.co/videos/presets/neon_flicker4.mp4",
  sequence: [FLICKER["variants"][0], STILL_EFFECT],
};

const DASH_PRESET = {
  title: "Dash",
  id: "dash",
  video: "https://assets.simplified.co/videos/presets/dash4.mp4",
  sequence: [FLY_IN_LEFT, STILL_EFFECT],
};

const LOCOMOTION_PRESET = {
  title: "Locomotion",
  id: "locomotion",
  video: "https://assets.simplified.co/videos/presets/locomotion4.mp4",
  sequence: [FLY_IN_LEFT, STILL_EFFECT],
};

const RISE_PRESET = {
  title: "Rise",
  id: "rise",
  video: "https://assets.simplified.co/videos/presets/rise4.mp4",
  sequence: [SHIFT_BOTTOM, STILL_EFFECT],
};

const PAN_PRESET = {
  title: "Pan",
  id: "pan",
  video: "https://assets.simplified.co/videos/presets/pan4.mp4",
  sequence: [SHIFT_LEFT, STILL_EFFECT],
};

const BREATHE_PRESET = {
  title: "Breathe",
  id: "breathe_preset",
  video: "https://assets.simplified.co/videos/presets/breathe4.mp4",
  sequence: [BREATHE.variants[0], STILL_EFFECT],
};

// export const presets = [ORIGINAL, BOUNCE_PRESET, FADE_PRESET, RISE_NOW, BUMPY, BLOCK_PRESET, POP_PRESET];
export const presets = [
  ORIGINAL,
  POP_PRESET,
  BASELINE_PRESET,
  DASH_PRESET,
  FADE_PRESET,
  ZOOM_PRESET,
  LOCOMOTION_PRESET,
  NEON_FLICKER_PRESET,
  RISE_PRESET,
  PAN_PRESET,
  BREATHE_PRESET,
  TEXT_BLOCK_PRESET,
  TEXT_POP_PRESET,
  TEXT_BASELINE_PRESET,
];
